import axios from '~/config/axios';
import getEnv from '../getEnv';

const context = getEnv('redecredenciada');

export default {
  googleMapsKey: async () => {
    let data;
    try {
      const response = await axios.get(`${context}/googlemaps/chave`);

      data = response?.data?.result;
    } catch (e) {
      const errorMessages = { messages: e.response?.data?.messages };
      throw errorMessages;
    }

    return data;
  },
};
